import { getAuth } from 'firebase/auth'

let refreshing: Promise<string | null> | null = null

// Asks Firebase rather than trusting localStorage: the timer that refreshes it stalls in background tabs and sleep.
export const getAuthToken = async (forceRefresh = false): Promise<string | null> => {
  try {
    const auth = getAuth()
    await auth.authStateReady()
    if (auth.currentUser) {
      const token = await auth.currentUser.getIdToken(forceRefresh)
      localStorage.setItem('token', token)
      return token
    }
  } catch (error) {
    console.error('Error getting auth token:', error)
  }
  return localStorage.getItem('token')
}

/** Forces a new token, sharing one refresh between requests that fail together. */
export const refreshAuthToken = (): Promise<string | null> => {
  refreshing ??= getAuthToken(true).finally(() => {
    refreshing = null
  })
  return refreshing
}
